import { Component, DestroyRef, ElementRef, inject, input, Input, OnInit, ViewChild, viewChild } from '@angular/core';
import * as _ from 'lodash';
import { Chart } from 'chart.js';
import { QuickInsightsService } from 'src/app/shared/services/quick-insights/quick-insights.service';
import { RatersService } from 'src/app/shared/services/raters/raters.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { MSG_CONST } from 'src/app/shared/constants/msg-constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { DownloadService } from 'src/app/shared/services/downloads/download.service';
import { NgIf, NgFor, NgStyle, DecimalPipe } from '@angular/common';
import { ScoreDropdownMenuComponent } from '../../../../shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { ScoreWidgetComponent } from '../../../../shared/components/score/score-widget/score-widget.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { ProjectScoreQuickInsightsPerformersComponent } from '../project-score-quick-insights-performers/project-score-quick-insights-performers.component';
import { ProjectScoreQuickInsightsCohortsComponent } from '../project-score-quick-insights-cohorts/project-score-quick-insights-cohorts.component';
import { TranslateModule } from '@ngx-translate/core';
import { getShowComparisonFlag, setShowComparisonFlag } from '../../../../shared/utils/score-deviation.util';


@Component({
    selector: 'app-project-score-quick-insights',
    templateUrl: './project-score-quick-insights.component.html',
    styleUrls: ['./project-score-quick-insights.component.scss'],
    imports: [NgIf, ScoreDropdownMenuComponent, ScoreWidgetComponent, NgFor, NgStyle, LtmsErrorComponent, LtmsLoaderComponent, ProjectScoreQuickInsightsPerformersComponent, ProjectScoreQuickInsightsCohortsComponent, DecimalPipe, TranslateModule]
})
export class ProjectScoreQuickInsightsComponent implements OnInit {
  changeLevelClickEvent:Subject<any> = new Subject();

  destroyRef = inject(DestroyRef);
  @Input() activeTab = '';
  @ViewChild('quickInsightChart', { static: true }) quickInsightChart!: ElementRef<HTMLCanvasElement>;
  isCompleteError: boolean = true;
  errorCode: string = '404';
  showDoughnut: boolean = false;
  private chartInstance: Chart | any;
  pagerBusy: boolean = true;
  levelText:any = MSG_CONST;
  viewBy = "Peers";
  targetHierarchyLevel: any = '';
  levelName = "";
  hierarchyStack: any = [];
  widgetData: any = {};
  distributions: any = [];
  accessName: any = {};
  isDataAvailable: boolean = true;
  showComparisonFlag: boolean = getShowComparisonFlag();
  totalResponses = 0;
  comarisonDistributionData: any = { percentage:[], color: []};
  csvFileContent = '\n\n';
  topPerformerData: any = [];
  bottomPerformerData: any = [];
  topCohortData: any = {};
  bottomCohortData: any = {};

  comparisonDropdown: any = {
    config: {
      'width': '280px',
      'tab': 'quick-insights',
      'component_id': 'quick-insights',
      'preffix': 'By ',
    },
    selectedOption: '', 
    options: []
  };
  selectedLevel: any = {};
  
  widgetTool: any = {
    isDownloadButtonShow: true,
  };
  
  topCohortsConfig = {
    'sortBy': 'desc',
    'size': 3
  }

  bottomCohortsConfig = {
    'sortBy': 'asc',
    'size': 3
  }
  dateType: any = '';
  dateTypeChanged: boolean = false;

  isAccountAccess: boolean = false;
  hierarchyStackData: any = [];
  constructor(
    private _quickInsights: QuickInsightsService,
    private _raters: RatersService,
    private _helpers: HelpersService,
    private downloadService: DownloadService,
  ) {  }

  ngOnInit() {
    let loggedInManager = _.get(Helpers, "managerDetails.loggedInManager");
    this.isAccountAccess = loggedInManager?.manager_type == 3? true: false;
    if(!this.isAccountAccess){
      this._helpers.appState.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response:any) => {
        if(response && !response.pending && response.hierarchyStack) {
            // Check if date changed
            this.dateTypeChanged = false;
            if(!_.isEmpty(this.dateType)) {
              if(this.dateType !== response.datePicker.trendType) {
                this.dateType = response.datePicker.trendType;
                this.dateTypeChanged = true;
              }
            }else {
              this.dateType = response.datePicker.trendType;
            }

            // Check if user access (hierarchy stack) changed
            if(!_.isEmpty(this.hierarchyStackData)) {
              if(this._helpers.generateHashForHierarchyStack(response.hierarchyStack) !== this._helpers.generateHashForHierarchyStack(this.hierarchyStackData)) {
                this.hierarchyStackData = response.hierarchyStack;
                this.callMethods(response, true)
              }else {
                this.callMethods(response);
              }
            }else {
              this.hierarchyStackData = response.hierarchyStack;
              this.callMethods(response);
            }
        }
      });
    }
  }
  callMethods(response, isHierarchyModified?) {
    this.comparisonDropdown.config['isHierarchyModified'] = isHierarchyModified;
    this.showDoughnut = false;
    this.hierarchyStack = response.hierarchyStack;
    // Prepare levels and retain previous value on date change
    if(!this.dateTypeChanged){
      this.comparisonDropdown.options = this.prepareLevels();
    }
    this.initializeComponent()
  }
  prepareLevels() {
    var hierarchyLevels = this._quickInsights.getHierarchyLevelList();
    var options: any = [];
    let lastPeerIndex = undefined;
    if(!_.isEmpty(hierarchyLevels) && this.hierarchyStack.length) {
        _.each(hierarchyLevels, (level, index) => {
            if(level && (level.value < this.hierarchyStack[0].field_id) && (level.value != this.hierarchyStack[0].field_id)) {
                lastPeerIndex = index;
                let obj = {
                    'field_id': level.value,
                    'value': level.value,
                    'name': level.name,
                    'type': 'hierarchy',
                    'category': 'Peers',
                    'preffix': 'within ',
                    'component_id': 'quick-insight',
                }
                options.push(obj)
            }else {
                if(level && level.value != this.hierarchyStack[0].field_id) {
                    let obj = {
                        'field_id': level.value,
                        'value': level.value,
                        'name': level.name,
                        'type': 'hierarchy',
                        'category': 'Comparisons',
                        'preffix': 'by ',
                        'component_id': 'quick-insight',
                    }
                    options.push(obj)
                }
            }
            
        })
    }
    if(lastPeerIndex == undefined) {
        this.viewBy = 'Comparisons';
        options[0]['isDefaultSelected'] = true;
        this.selectedLevel = options[0];
        this.targetHierarchyLevel = options[0]['field_id'];
    }else {
        for(let i=0; i<options.length; i++) {
            if(options[i].field_id == lastPeerIndex) {
                this.viewBy = 'Peers';
                options[i]['isDefaultSelected'] = true;
                this.selectedLevel = options[i];
                this.targetHierarchyLevel = options[i]['field_id'];
                break;
            }
        }
    }
    this.comparisonDropdown.selectedOption = this.selectedLevel?.preffix + this.selectedLevel?.name
    return options;
  }
  initializeComponent() {
    var access = Helpers.getHierarchyStack();
    var levelMap = this._quickInsights.getHierarchyLevelList();
    this.levelName = "";
    if (access && access.length && access[0].group_key[0]) {
      this.accessName = (Helpers.groupKeyMapping && !_.isEmpty(Helpers.groupKeyMapping)&& Helpers.groupKeyMapping[access[0].group_key[0]])?Helpers.groupKeyMapping[access[0].group_key[0]]:access[0].group_key[0];
      if (levelMap && levelMap[access[0].field_id]) {
          this.levelName = levelMap[access[0].field_id].name;
      }
    } else {
        this.accessName = Helpers.brandDetails.name;
    }
    if (this.levelName == "" && Object.keys(levelMap).length) {
        this.levelName = levelMap[Object.keys(levelMap)[0]].name;
    }
    this.levelName = this.levelName.replace('Within ', '');
    let raterType = Helpers.brandDetails.main_rater_type;
    let distribution = this._raters.getRaterDetails(raterType).distributions;
    this.getOverallData();
  }
  getOverallData() {
    this.pagerBusy = true;
    var access = this.hierarchyStack;
    if (!(access && access.length)) {
        this.isDataAvailable = false;
        return;
    }
    access = access[0];
    let params = {
        "brand_id": _.get(Helpers, "brandDetails._id"),
        "main_rater_type": _.get(Helpers, "brandDetails.main_rater_type"),
        "from": _.get(Helpers, "datePicker.startDate"),
        "to": _.get(Helpers, "datePicker.endDate"),
        "is_custom_date_range_selected": false,
        "hierarchy_level": access.field_id,
        "hierarchy_value": access.group_key[0],
        "field_type":"hierarchy"
    }

    this._quickInsights.getLeaderboardSummary(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(response => {
      response = response.data;
      if (response && response.code == 0 && response.summary && response.summary[params.hierarchy_value]) {
          response = response.summary[params.hierarchy_value];
          this.prepareDataForWidget(response, access.field_id);
      } else {
          this.pagerBusy = false;
          this.widgetData = {};
          this.isDataAvailable = false;
      }
    })
  }

  prepareDataForWidget(response, accessLevel) {
    var widgetData: any = {comparisons: []};
    var mainRaterType = Helpers.brandDetails.main_rater_type;
    var raterDetails = this._raters.getRaterDetails(mainRaterType);
    if (!(response.current && (Object.keys(response.current)).length)) {
      response.current = this.getDefaultResponse();
    } 
    if (!(response.previous && (Object.keys(response.previous)).length)) {
        response.previous = this.getDefaultResponse();
    }
    var quartile = {
      "title": "Quartile",
      "value": response.current.quartile,
      "preValue": response.previous.quartile,
      "val_type": "text",
      "accessLevel": accessLevel
    }
    var score: any = {
      "title": mainRaterType == 3 ? Helpers.getDisplayLabel('NPS') : Helpers.getDisplayLabel('Rating'),
      "value": mainRaterType == 3 ? parseInt((response.current.net_promoter_score).toFixed(0)): parseInt((response.current.average_rating).toFixed(1)),
      "preValue": mainRaterType == 3 ? parseInt((response.previous.net_promoter_score).toFixed(0)): parseInt((response.previous.average_rating).toFixed(1)),
    }
    score.deviation = Helpers.getFieldDeviation(score.value, score.preValue);

    var responses: any = {
      "title": "Responses",
      "value": response.current.number_of_users_rated_primary_rating,
      "preValue": response.previous.number_of_users_rated_primary_rating,
    }
    responses.deviation = Helpers.getFieldDeviation(responses.value, responses.preValue);
    if (responses.value == 0) {
      score.value = 'N/A';
      score.val_type = "text";
    }
    // if (accessLevel != 'h_0_0') {
    //     widgetData.comparisons.push(quartile);
    // }
    // Commented this code because need quartile value in CSV & for UI display added condition in html to not display quartile value for access's level h_0_0
    widgetData.comparisons.push(quartile);
    widgetData.comparisons.push(score);
    widgetData.comparisons.push(responses);
    if (raterDetails && raterDetails.distributions) {
      this.totalResponses = 0;
      for(var idx in raterDetails.distributions) {
          raterDetails.distributions[idx].rated = response.current[raterDetails.distributions[idx].field_id];
          this.totalResponses += raterDetails.distributions[idx].rated;
      }
    }
    widgetData.distribution = raterDetails.distributions;
    widgetData.options = {
      "showComparison": true, // Have to assign dynamic this value
      "distributionType": "percentage"
    }

    this.widgetData = widgetData;
    this.distributions = raterDetails.distributions;
    this.isDataAvailable = true;
    response.current.name = this.accessName;
    this.prepareDistributionPercentage()
  }
  showComparison(event: any) {
      this.showComparisonFlag = event.currentTarget.checked;
      setShowComparisonFlag(this.showComparisonFlag);
  }
  getPositiveValue(value) {
    if (value == 0 || value < 0) {
      return -(value);
    }
    return value;
  }
  numberFormatting(value) {
    return Helpers.INRCurrencyPipeFilter(value);
  }
  getDefaultResponse() {
    return {
      rank: 0,
      detractors: 0,
      quartile: null,
      promoters: 0,
      total_number_of_records: 0,
      passives: 0,
      negatives: 0,
      primary_rating_distribution: [],
      positives: 0,
      total_response: 0,
      net_promoter_score: 0,
      number_of_users_rated_primary_rating: 0,
      average_rating: 0
  }
  }
  drawDoughnnutChart() {
    this.destroyChart()
    const ctx = this.quickInsightChart.nativeElement.getContext('2d');
    if (ctx) {
        this.showDoughnut = true;
        this.chartInstance = new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [
            { 
                data: this.comarisonDistributionData.percentage,
                backgroundColor: this.comarisonDistributionData.color,
                hoverOffset: 0,
                borderWidth: 0,
            },
            ],
        },
        options: {
            cutout: 35,
            responsive: false,
            plugins: {
                tooltip: {
                    enabled: false
                },
                legend: {
                    display: false
                }
            },
            hover: {
              mode: 'nearest' // Use a valid mode; 'nearest' is the most neutral
            },
            animation: {
              duration: 0, // Disable animation (optional, for instant updates)
            }
        }
        });
    }
    this.pagerBusy = false;
  }
  prepareDistributionPercentage() {
    this.comarisonDistributionData = {percentage:[], color: []};
    if (this.widgetData.options && this.widgetData.options.distributionType == 'percentage' && this.widgetData.distribution && this.widgetData.distribution.length > 0) {
      this.widgetData.distribution.forEach(singleRating => {
        let percentage = (singleRating.rated / this.totalResponses) * 100;
        this.comarisonDistributionData['percentage'].push(percentage)
        this.comarisonDistributionData['color'].push(singleRating.color)
        singleRating['percentage'] = percentage;
      });
    }
    this.drawDoughnnutChart()
  }
  changeLevel(event) {
    this.viewBy = event.category;
    this.selectedLevel = event;
    this.targetHierarchyLevel = this.selectedLevel['field_id'];
    this.changeLevelClickEvent.next({'level': this.selectedLevel});
  }
  ngOnDestroy() {
  }
  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }
  onDownload(): void {

    this.csvFileContent = '';

    if(!_.isEmpty(this.widgetData)) {
      let csvContent = this.prepareDataIntoCSV();
      this.csvFileContent += csvContent + '\n\n';
    }

    if(!_.isEmpty(this.topPerformerData)) {
      let topPerformerContent = this.prepareDataIntoCSVTopPerformer(this.topPerformerData);
      this.csvFileContent += topPerformerContent + '\n\n';
    }

    if(!_.isEmpty(this.bottomPerformerData)) {
      let bottomPerformerContent = this.prepareDataIntoCSVBottomPerformer(this.bottomPerformerData);
      this.csvFileContent += bottomPerformerContent + '\n\n';
    }

    if(!_.isEmpty(this.topCohortData?.response)) {
      let topCohortContent = this.prepareDataIntoCSVCohortData(this.topCohortData, 'Top');
      this.csvFileContent += topCohortContent + '\n\n';
    }

    if(!_.isEmpty(this.bottomCohortData?.response)) {
      let bottomCohortContent = this.prepareDataIntoCSVCohortData(this.bottomCohortData, 'Bottom');
      this.csvFileContent += bottomCohortContent + '\n\n';
    }

    this.conbineFileContent(this.csvFileContent);
  }
  // Export Top cohort data to CSV download
  exportTopCohortDataToDownloadCSV(data) {
    this.topCohortData = data;
  }
  // Export Bottom cohort data to CSV download
  exportBottomCohortDataToDownloadCSV(data) {
    this.bottomCohortData = data;  
  }
  // Export Top performer data to CSV download
  csvTopPerformerExportData(data) {
    this.topPerformerData = data;
  }
  // Export Bottom performer data to CSV download
  csvBottomPerformerExportData(data) {
    this.bottomPerformerData = data;
  }
  prepareTableInfoToCSV() {
    let obj = {
      'Report name :': `Quick Insights - ${this.selectedLevel?.preffix} ${this.selectedLevel?.name}`,
      'Report Date :': `${moment(Helpers?.datePicker?.formatedStartDate, "DD MMM' YY").format('DD-MMM-YYYY')} - ${moment(Helpers?.datePicker?.formatedEndDate, "DD MMM' YY").format('DD-MMM-YYYY')}`,
      'For Account :': Helpers?.accountDetails?.display_name || Helpers?.accountDetails?.name,
      'For Project :': Helpers?.brandDetails?.display_name || Helpers?.brandDetails?.name,
      'Downloaded On :': moment().format('DD-MMM-YYYY hh:mm:ss a'),
      'Downloaded By :': Helpers?.managerDetails?.manager?.email_address
    };
    const rows = Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string' && (value.includes(',') || value.includes('\n') || value.includes('"'))) {
        value = `"${value.replace(/"/g, '""')}"`;
      }
      return `${key},${value}`;
    });
    const csv = rows.join('\n');
    return csv;
  }
  prepareDataIntoCSVCohortData(event, type) {
    var dataArr: any = [];
    if(event.column && event.column.length > 0) {
      event.response.forEach(data => {
        var reportContent = {};
        event.column.forEach(label => {
          if(label.csv_header == 'Name') {
            reportContent[type + ' ' + event?.cohort] = data[label['uniqueId']];
          }else {
            if(label.csv_header == 'Passives' || label.csv_header == 'Promoters' || label.csv_header == 'Detractors') {
              reportContent[label.csv_header] = data[label['csv_header'].toLowerCase()];

            }else {
              reportContent[label.csv_header] = data[label['uniqueId']];
            }
          }
        });
        event.column.forEach(label => {
          if(label.csv_header == 'Passives' || label.csv_header == 'Promoters' || label.csv_header == 'Detractors') {
            reportContent[label.csv_header + '%'] = this.parseFloatPerventageValue(data[label['uniqueId']]);
          }
        })
        dataArr.push(reportContent)
      });

      var csvRows: any = [];
      const headers = Object.keys(dataArr[0]);
      csvRows.push(headers.join(','));
      dataArr.forEach(element => {
        const values = Object.values(element).join(',');
        csvRows.push(values)
      });
      const csvContent = csvRows.join('\n');
      return csvContent;
    }
  }
  prepareDataIntoCSV() {
    var reportContent: any = {}
    reportContent[this.levelName] = this.accessName;
    this.widgetData.comparisons.forEach(data => {
      reportContent[data.title] = data.value;
    });
    this.widgetData.distribution.forEach(data => {
      reportContent[data.label] = data.rated;
    });
    this.widgetData.distribution.forEach(data => {
      reportContent[data.label+'%'] = this.parseFloatPerventageValue(data.percentage);
    });
    var csvRows: any = [];
    const headers = Object.keys(reportContent);
    csvRows.push(headers.join(','));
    const values = Object.values(reportContent).join(',');
    csvRows.push(values)
    const csvContent = csvRows.join('\n');
    return csvContent;
  }
  prepareDataIntoCSVTopPerformer(topPerformerData) {
    var dataArr:any = [];
    topPerformerData.forEach(data => {
      var reportContent = {};
      data.comparisons.forEach(obj => {
        reportContent[obj.title?obj.title:'Top Performers'] = obj.value;
      });
      data.distribution.forEach(obj => {
        reportContent[obj.label] = obj.rated;
      });
      data.distribution.forEach(obj => {
        reportContent[obj.label+'%'] = this.parseFloatPerventageValue(obj.percentage);
      });
      dataArr.push(reportContent);
    });
    var csvRows: any = [];
    const headers = Object.keys(dataArr[0]);
    csvRows.push(headers.join(','));
    dataArr.forEach(element => {
      const values = Object.values(element).join(',');
      csvRows.push(values);
    });
    const csvContent = csvRows.join('\n');
    return csvContent;

  }
  prepareDataIntoCSVBottomPerformer(bottomPerformerData) {
    var dataArr:any = [];
    bottomPerformerData.forEach(data => {
      var reportContent = {};
      data.comparisons.forEach(obj => {
        reportContent[obj.title?obj.title:'Bottom Performers'] = obj.value;
      });
      data.distribution.forEach(obj => {
        reportContent[obj.label] = obj.rated;
      });
      data.distribution.forEach(obj => {
        reportContent[obj.label+'%'] = this.parseFloatPerventageValue(obj.percentage);
      });
      dataArr.push(reportContent);
    });
    var csvRows: any = [];
    const headers = Object.keys(dataArr[0]);
    csvRows.push(headers.join(','));
    dataArr.forEach(element => {
      const values = Object.values(element).join(',');
      csvRows.push(values)
    });
    const csvContent = csvRows.join('\n');
    return csvContent;
  }
  parseFloatPerventageValue(value) {
    return parseFloat(value).toFixed(2)
  }
  conbineFileContent(data) {
    let tableInfo = this.prepareTableInfoToCSV();
    let combinedCSV = tableInfo + '\n\n' + data;
    this.sendReportForDownload(combinedCSV);
  }
  sendReportForDownload(processedFile: any) {
    var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(processedFile);
    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: `Quick Insights - ${this.selectedLevel?.preffix} ${this.selectedLevel?.name} Report - ${moment().format('DD-MMM-YYYY')}`,
      orignal_filename: `Quick Insights - ${this.selectedLevel?.preffix} ${this.selectedLevel?.name} Report - ${moment().format('DD-MMM-YYYY')}` + ".csv",
      fileType: 'csv',
      dataSource: 'dashboard',
      progress: 100,
      uri: uri
    };
    this.downloadService.updateList(downloadData);
    this.downloadService.showDownloadSideBar(true);
  }
  isTypeText(comparison) {
    if(comparison.val_type == 'text') {
      return true;
    }else {
      return false;
    }
  }
}
